export const districtUsageIntroSteps = [
  {
    element: '#printButton',
    intro: 'Click here to print the WordFlight System Usage School Report.'
  },
  {
    element: '.report',
    intro: 'Usage is where you can view WordFlight System usage data. You can see WordFlight System enrollment, percentage of students started, usage trends, weekly time goals, and more.'
  },
  {
    element: '#district-report-usage-enrollment',
    intro: 'See the number of students enrolled in the WordFlight System.'
  },
  {
    element: '#district-report-usage-started',
    intro: 'See the percentage of students who have started in the WordFlight System.'
  },
  {
    element: '#district-report-usage-trend',
    intro: 'See the graph which shows the average minutes per week trend across the school year for the school.'
  },
  {
    element: '#loginDateRange',
    intro: 'Select a date range from the dropdown to view WordFlight System usage data for that week.'
  },
  {
    element: '#district-report-usage-logins',
    intro: 'See the percentage of students with at least one login, and the percentage of students with at least two logins within the selected date range.'
  },
  {
    element: '#weeklyTimeGoal',
    intro: 'See the average weekly usage in minutes, the minimum weekly usage goal in minutes, and the distribution of student usage within the selected date range.'
  },
  {
    element: '.district-report-row:nth-child(3)',
    intro: 'Click the plus sign to view WordFlight System usage data sorted by teacher. See the teacher’s name, the grades they teach, their school, their number of teacher logins, and the percentage of students hitting their minimum weekly time goal within the selected date range.'
  }
];